// Authentication component
import { login as apiLogin } from '../api/client.js';
import { updateAuthState, getAuthState } from '../state/store.js';

// DOM Elements
let loginModal;
let loginForm;
let loginError;
let logoutBtn;

export function initAuth() {
  createLoginModal();
  setupLogoutButton();
  
  // Check if user is already logged in
  const authState = getAuthState();
  if (authState.token) {
    showLoggedInState();
  } else {
    showLoginModal();
  }
}

function createLoginModal() {
  // Create login modal HTML
  const modalHTML = `
    <div id="loginModal" class="modal">
      <div class="modal-content">
        <div class="login-container">
          <div class="login-header">
            <img src="/socialcard_logo_rgb_unterzeile_72dpi.png" alt="Logo" class="login-logo">
            <h2>SocialCard Assistent</h2>
            <p>Bitte melden Sie sich an</p>
          </div>
          <form id="loginForm" class="login-form">
            <div class="form-group">
              <label for="username">Benutzername</label>
              <input type="text" id="username" name="username" required autocomplete="username">
            </div>
            <div class="form-group">
              <label for="password">Passwort</label>
              <input type="password" id="password" name="password" required autocomplete="current-password">
            </div>
            <div id="loginError" class="login-error" style="display: none;"></div>
            <button type="submit" class="btn-login">Anmelden</button>
          </form>
        </div>
      </div>
    </div>
  `;
  
  // Add modal to body
  document.body.insertAdjacentHTML('beforeend', modalHTML);
  
  // Get DOM elements
  loginModal = document.getElementById('loginModal');
  loginForm = document.getElementById('loginForm');
  loginError = document.getElementById('loginError');
  
  // Setup form submission
  loginForm.addEventListener('submit', handleLogin);
}

function setupLogoutButton() {
  // Create logout button in header
  const headerWrapper = document.querySelector('.header-wrapper');
  if (headerWrapper) {
    const logoutHTML = `
      <button id="logoutBtn" class="btn-logout" style="display: none;">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 14l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h6a2 2 0 012 2v1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Abmelden
      </button>
    `;
    headerWrapper.insertAdjacentHTML('beforeend', logoutHTML);
    
    logoutBtn = document.getElementById('logoutBtn');
    logoutBtn.addEventListener('click', handleLogout);
  }
}

async function handleLogin(e) {
  e.preventDefault();
  
  const username = document.getElementById('username').value;
  const password = document.getElementById('password').value;
  
  try {
    // Show loading state
    const submitBtn = loginForm.querySelector('button[type="submit"]');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Anmelden...';
    hideLoginError();
    
    // Call login API
    const response = await apiLogin(username, password);
    
    // Store token
    updateAuthState({
      token: response.access_token,
      username: username,
      isAuthenticated: true,
    });
    
    // Hide modal and show app
    hideLoginModal();
    showLoggedInState();
    
    // Trigger data loading
    window.dispatchEvent(new CustomEvent('auth-success'));
    
  } catch (error) {
    showLoginError(error.message || 'Anmeldung fehlgeschlagen');
    
    // Reset button
    const submitBtn = loginForm.querySelector('button[type="submit"]');
    submitBtn.disabled = false;
    submitBtn.textContent = 'Anmelden';
  }
}

function handleLogout() {
  // Clear auth state
  updateAuthState({
    token: null,
    username: null,
    isAuthenticated: false,
  });
  
  // Show login modal
  showLoginModal();
  showLoggedOutState();
  
  // Clear form and reset button state
  if (loginForm) {
    loginForm.reset();
    const submitBtn = loginForm.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Anmelden';
    }
  }
  hideLoginError();
}

function showLoginModal() {
  if (loginModal) {
    loginModal.style.display = 'flex';
  }
}

function hideLoginModal() {
  if (loginModal) {
    loginModal.style.display = 'none';
  }
}

function showLoginError(message) {
  if (loginError) {
    loginError.textContent = message;
    loginError.style.display = 'block';
  }
}

function hideLoginError() {
  if (loginError) {
    loginError.style.display = 'none';
  }
}

function showLoggedInState() {
  // Show logout button
  if (logoutBtn) {
    logoutBtn.style.display = 'flex';
  }
  
  // Show main content
  const mainContent = document.querySelector('.main-content');
  if (mainContent) {
    mainContent.style.display = 'block';
  }
}

function showLoggedOutState() {
  // Hide logout button
  if (logoutBtn) {
    logoutBtn.style.display = 'none';
  }
  
  // Hide main content
  const mainContent = document.querySelector('.main-content');
  if (mainContent) {
    mainContent.style.display = 'none';
  }
}

// Check if token is expired (basic check)
export function isTokenExpired(token) {
  if (!token) return true;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp * 1000; // Convert to milliseconds
    return Date.now() >= exp;
  } catch (error) {
    return true;
  }
}

// Auto-logout on token expiration
export function setupTokenExpirationCheck() {
  setInterval(() => {
    const authState = getAuthState();
    if (authState.token && isTokenExpired(authState.token)) {
      handleLogout();
    }
  }, 60000); // Check every minute
}
